const EnSvgIcon = ({ width, height }) => (
  <svg width={width} height={height} viewBox="0 0 23 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7277_21487)">
      <rect x="0.0859375" y="0.111328" width="22.0877" height="15.7769" rx="3.15539" fill="#1A47B8" />
      <path fillRule="evenodd" clipRule="evenodd" d="M2.43562 0.111328H0.0859375V2.74082L19.8112 15.8883L22.1737 15.8883V13.2588L2.43562 0.111328Z" fill="white" />
      <path d="M0.869629 0.111328L22.1737 14.3478V15.8883H21.4083L0.0859375 1.63702V0.111328H0.869629Z" fill="#F93939" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0701 0.111328H22.1737V2.74082C22.1737 2.74082 8.51062 11.5002 2.18953 15.8883H0.0859375V13.2588L20.0701 0.111328Z"
        fill="white"
      />
      <path d="M22.1737 0.111328H21.4603L0.0859375 14.3601V15.8883H0.869629L22.1737 1.64854V0.111328Z" fill="#F93939" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.11858 0.111328H14.1594V4.9778H22.1737V11.0186H14.1594V15.8883H8.11858V11.0186H0.0859375V4.9778H8.11858V0.111328Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38603 0.111328H12.8736V6.17938H22.1737V9.82021H12.8736V15.8883H9.38603V9.82021H0.0859375V6.17938H9.38603V0.111328Z"
        fill="#F93939"
      />
    </g>
    <defs>
      <clipPath id="clip0_7277_21487">
        <rect x="0.0859375" y="0.111328" width="22.0877" height="15.7769" rx="3.15539" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const EngIconMobile = (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_7758_2029)">
      <path d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z" fill="#F0F0F0" />
      <path d="M2.4813 4.69531C1.53869 5.9217 0.827922 7.33522 0.414062 8.8708H6.65678L2.4813 4.69531Z" fill="#0052B4" />
      <path d="M23.5864 8.87075C23.1725 7.33522 22.4617 5.9217 21.5191 4.69531L17.3438 8.87075H23.5864Z" fill="#0052B4" />
      <path d="M0.414062 15.1328C0.827969 16.6683 1.53873 18.0819 2.4813 19.3082L6.65664 15.1328H0.414062Z" fill="#0052B4" />
      <path d="M19.3083 2.48135C18.0819 1.53874 16.6684 0.827969 15.1328 0.414062V6.65674L19.3083 2.48135Z" fill="#0052B4" />
      <path d="M4.69531 21.5191C5.9217 22.4617 7.33522 23.1725 8.87075 23.5864V17.3438L4.69531 21.5191Z" fill="#0052B4" />
      <path d="M8.8707 0.414062C7.33517 0.827968 5.92166 1.53873 4.69531 2.4813L8.8707 6.65668V0.414062Z" fill="#0052B4" />
      <path d="M15.1328 23.5864C16.6683 23.1725 18.0819 22.4617 19.3082 21.5191L15.1328 17.3438V23.5864Z" fill="#0052B4" />
      <path d="M17.3438 15.1328L21.5191 19.3082C22.4617 18.0819 23.1725 16.6683 23.5864 15.1328H17.3438Z" fill="#0052B4" />
      <path
        d="M23.8984 10.4348H13.5653H13.5653V0.101578C13.0529 0.034875 12.5305 0 12 0C11.4694 0 10.9471 0.034875 10.4348 0.101578V10.4347V10.4347H0.101578C0.034875 10.9471 0 11.4695 0 12C0 12.5306 0.034875 13.0529 0.101578 13.5652H10.4347H10.4347V23.8984C10.9471 23.9651 11.4694 24 12 24C12.5305 24 13.0529 23.9652 13.5652 23.8984V13.5653V13.5653H23.8984C23.9651 13.0529 24 12.5306 24 12C24 11.4695 23.9651 10.9471 23.8984 10.4348Z"
        fill="#D80027"
      />
      <path d="M15.1328 15.1329L20.4876 20.4877C20.7339 20.2415 20.9688 19.9841 21.193 19.7173L16.6085 15.1328H15.1328V15.1329Z" fill="#D80027" />
      <path d="M8.87048 15.1328H8.87039L3.51562 20.4876C3.76181 20.7339 4.0192 20.9688 4.28602 21.193L8.87048 16.6084V15.1328Z" fill="#D80027" />
      <path d="M8.87269 8.87058V8.87048L3.51788 3.51562C3.27159 3.76181 3.03666 4.0192 2.8125 4.28602L7.39702 8.87053H8.87269V8.87058Z" fill="#D80027" />
      <path d="M15.1328 8.86883L20.4877 3.51392C20.2415 3.26764 19.9841 3.0327 19.7173 2.80859L15.1328 7.39311V8.86883Z" fill="#D80027" />
    </g>
    <defs>
      <clipPath id="clip0_7758_2029">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const RouteStartIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Icon_2"
        d="M4 15C4 15 5 14 8 14C11 14 13 16 16 16C19 16 20 15 20 15V3C20 3 19 4 16 4C13 4 11 2 8 2C5 2 4 3 4 3V15ZM4 15V22"
        stroke={color || '#2055FF'}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const TurnLeftIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Icon_2"
        d="M9 14L4 9M4 9L9 4M4 9H16C17.0609 9 18.0783 9.42143 18.8284 10.1716C19.5786 10.9217 20 11.9391 20 13V20"
        stroke={color || '#101828'}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const TurnRightIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Icon_2"
        d="M15 14L20 9M20 9L15 4M20 9H8C6.93913 9 5.92172 9.42143 5.17157 10.1716C4.42143 10.9217 4 11.9391 4 13V20"
        stroke={color || '#101828'}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const DestinationIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <g id="Icon_2">
        <path
          d="M21 10C21 17 12 23 12 23C12 23 3 17 3 10C3 7.61305 3.94821 5.32387 5.63604 3.63604C7.32387 1.94821 9.61305 1 12 1C14.3869 1 16.6761 1.94821 18.364 3.63604C20.0518 5.32387 21 7.61305 21 10Z"
          stroke={color || '#2055FF'}
          strokeWidth="1.92"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z"
          stroke={color || '#2055FF'}
          strokeWidth="1.92"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </g>
  </svg>
);

export const ElevatorIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon">
      <path
        id="Icon_2"
        d="M12 3V21M12 3H19C19.5304 3 20.0391 3.21071 20.4142 3.58579C20.7893 3.96086 21 4.46957 21 5V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H12V3ZM12 3H5C4.46957 3 3.96086 3.21071 3.58579 3.58579C3.21071 3.96086 3 4.46957 3 5V19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H12V3Z"
        stroke={color || '#101828'}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);

export const StairsIcon = ({ color }: { color?: string }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="Icon" clipPath="url(#clip0_7582_69392)">
      <path
        id="Icon_2"
        d="M15.5376 2.49999C14.8748 2.5 14.3395 3.03726 14.3395 3.7V8.50003H9.03951C8.37677 8.50003 7.83951 9.03729 7.83951 9.70003V14.9338C7.83951 14.9338 5.55645 14.9338 2.20082 14.9339C1.53809 14.9339 1 15.4705 1 16.1333C0.999998 17.7418 1.00001 20.2293 1.00001 20.9339L20.3951 20.9338C21.7451 20.9338 22.8395 19.8892 22.8395 18.6005V2.5C17.977 2.49999 16.2816 2.49999 15.5376 2.49999Z"
        stroke={color || '#101828'}
        strokeWidth="2.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_7582_69392">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const StraightArrowIcon = ({ color }: { color?: string }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M12 19V5M12 5L19 12M12 5L5 12" stroke={color || '#101828'} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ZoomInIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path d="M12 5.33325L12 19.3333M5 12.3333L19 12.3333" stroke="#101828" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ZoomOutIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
    <path d="M19 12.3333L5 12.3333" stroke="#101828" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ZoomExpandIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
    <path
      d="M0.00395432 11.9117H1.54092L1.54092 12.2273L1.53974 16.7109C1.535 16.7613 1.54152 16.7832 1.55573 16.7991C1.55632 16.7997 1.56342 16.8021 1.65401 16.7926H6.42181V18.3302L0.768295 18.3296C0.53029 18.3474 0.325439 18.2846 0.183346 18.1253C0.0643438 17.9921 -0.000782081 17.84 0.0045464 17.6748L0.0045464 11.9117H0.00395432ZM0.176242 0.548468C0.321887 0.390388 0.527921 0.324671 0.751718 0.337696H6.42181V1.87111L1.60783 1.86993C1.56401 1.86579 1.55217 1.86993 1.54507 1.87704C1.53974 1.88236 1.53382 1.90368 1.54092 1.99426L1.54092 6.75614H0.00395432L0.00395432 6.44058L0.00573049 1.1417C-0.0185437 0.908436 0.033557 0.702993 0.176242 0.548468ZM17.9941 1.13815L17.9941 6.75674H16.4583L16.4583 1.95163C16.4595 1.89184 16.453 1.87289 16.4553 1.87467C16.4577 1.87644 16.4376 1.87111 16.3624 1.87407L11.5768 1.87407V0.337696L17.1238 0.338287C17.4091 0.318157 17.6353 0.367298 17.7957 0.517088C17.9615 0.672205 18.0189 0.896593 17.9947 1.13756L17.9941 1.13815ZM17.2889 18.3308L11.5762 18.3308V16.7873L16.4133 16.7879C16.4352 16.7891 16.4405 16.7873 16.4512 16.7755C16.4518 16.7749 16.4607 16.7364 16.4512 16.6144V11.9123H17.9935V12.2279L17.9929 17.5907C18.0041 17.8133 17.9432 18.0063 17.7981 18.1461C17.659 18.2805 17.476 18.3409 17.2884 18.3308H17.2889Z"
      fill="#101828"
    />
  </svg>
);

export const ZoomUpIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M18 15L12 9L6 15" stroke="#101828" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const ZoomDownIcon = (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6 9L12 15L18 9" stroke="#98A2B3" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default EnSvgIcon;
